
export class ProgramServiceConfig {
    Id = 0;
    Code: string;
    Description: string;
    Sequence = 0;
    SystemProgram = false;
    PermissionsCategory = '';
    DisplayToParents = false;
    DisplayToStudents = false;
    ProgramServices: Services[];
    HasAlert = false;
    IsInActive = false;
    UserHasViewPermission = false;
    UserHasEditPermission = false;
    UserHasDeletePermission = false;
}

export class Services {
    Id = 0;
    Code: string;
    Description: string;
    ProgramCodeId: number;
    Sequence: number;
    SystemService = false;
    ImageName = '';
    ImageData = '';
    TrackServiceImport = 0;
    StateCode = '';
    Inactive = false;
    ServiceFields: ServiceFields[];

    // Local Property
    IsEdited = false;
}

export class ServiceFields {
    Id = 0;
    Name: string;
    Description: string;
    TypeId = 0;
    Type: string;
    Length = 0;
    Decimals = 0;
    Sequence: number;
    ServiceCodeId: number;
    ProgramServiceField = ''; // Name of Column in ProgramServiceCode table,  associated for the Custom Fields
    Match = false; // Use this field in where cluase while import
    FieldLookups: FieldLookups[] = [];

    // Local property
    StrAlphaNumericLength = '';
    StrNumericLength = '';
    StrNumericDecimals = '';
}

export class FieldLookups {
    Id = 0;
    ServiceFieldId: number;
    Code: string;
    Description = '';
    Inactive = false;
    Sequence = 0;
    FieldName = '';
    // Local Properties
    Edit = false;
}

export class ImportFile {
    Data = '';
    Name = '';
    Type = 'text/xml';
    ProgramDescription = '';
    ImportOption = 0;
}

export class ImportData {
    YearId: number;
    SiteId: number;
    File: string;
    FileName: string;
    MatchIdOption: number;
    ProgramServiceOverrideSetting: boolean;
    ProgramServerOverrideOption: number;
}

